import { type Epic, combineEpics } from 'redux-observable';
import { filter, map } from 'rxjs';
import { request } from '@/core';
import { verifyUserRequest } from '@/api/user';
import { navigate } from '@/utils/operators';
import { verifyUser, setUser } from '../actions';

const verifyUserEpic: Epic = (action$) =>
  action$.pipe(
    filter(verifyUser.match),
    request(verifyUserRequest, verifyUser),
  );

const verifyUserSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(verifyUser.succeeded.match),
    map(({ payload: { data: user } }) => setUser(user)),
  );

const verifyUserFailedEpic: Epic = (action$) =>
  action$.pipe(
    filter(verifyUser.failed.match),
    navigate({ to: '/auth/login' }),
  );

export default combineEpics(
  verifyUserEpic,
  verifyUserSucceededEpic,
  verifyUserFailedEpic,
);
